import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "./assets/scss/config.scss";

import VueSignaturePad from "vue-signature-pad";
Vue.use(VueSignaturePad);

// import msal from "vue-msal";

// Vue.use(msal, {
//   auth: {
//     clientId: process.env.VUE_APP_CLIENTID,
//     authority: process.env.VUE_APP_AUTHORITY,
//     redirectUri: location.origin,
//     navigateToLoginRequestUrl: true,
//     postLogoutRedirectUri: location.origin,
//     // beforeSignOut: (ctx) => {
//     //   // var preferred_username;
//     //   console.info("beforeSignOut.options", JSON.stringify(ctx.options));
//     //   console.info("beforeSignOut.data", JSON.stringify(ctx.data));
//     //   console.info("beforeSignOut.auth", JSON.stringify(ctx.auth));
//     // }
//   },
//   cache: {
//     cacheLocation: "localStorage",
//     storeAuthStateInCookie: true,
//   },
//   request: {
//     scopes: ["User.Read"],
//     //loginHint: "O.CiQxNmI3MGNhNC04ZGNiLTQ4YTItODc1ZS1kYTBlZjk2NWQyZjkSJDAwMjFkNTBhLTgzMjAtNDg1Yi05MmY1LWM2MWVkMTI5MGE1NxoUaGVucmlrc0B0cnlzaWxodXMubm8gVw==",
//     //loginHint: "henriks@trysilhus.no",
//     //extraQueryParameters: { domain_hint: "trysilhus.onmicrosoft.com" }
//   },
// });

import moment from "moment";
import vueMoment from "vue-moment";

moment.locale("nb");
Vue.use(vueMoment, {
  moment,
});

import ibmBlobLink from "@/directives/ibmBlobLink";
Vue.directive("ibmBlobLink", ibmBlobLink);

import haveRoleFilter from "@/directives/haveRoleFilter";
Vue.directive("haveRoleFilter", haveRoleFilter);

import * as Sentry from "@sentry/vue";
import { BrowserTracing } from "@sentry/tracing";

Sentry.init({
  Vue,
  environment: process.env.VUE_APP_ENVIRONMENT,
  dsn: "https://83779e8e75e541019e283f6750d5b2a2@o100875.ingest.sentry.io/4504259361898496",
  integrations: [
    new BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracePropagationTargets: [location.origin, /^\//],
    }),
  ],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
  // created() {
  //   debugger;
  //   if (!(this as any).$msal.isAuthenticated()) {
  //     (this as any).$msal.signIn();
  //   }
  // },
}).$mount("#app");
